import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { rio } from '@amzn/rio-design-tokens';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
const ImageContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: ${({ fullscreen }) => (fullscreen === 'true' ? 'start' : 'center')};
  // For PDP product images purposes
  min-height: calc(100vw - 45px);

  img {
    max-height: ${({ fullscreen }) => (fullscreen === 'true' ? '100%' : 'MIN(calc(100vh - 250px), 100vw)')};
    width: 100%;
    object-fit: contain;
  }
`;
const StyledSwiper = styled(Swiper) `
  background-color: ${rio.semantic.color.background.primary};

  .swiper-wrapper {
    max-height: ${({ fullscreen }) => (fullscreen === 'true' ? '100%' : 'MIN(calc(100vh - 250px), 100vw)')};
    align-items: ${({ fullscreen }) => (fullscreen === 'true' ? 'start' : 'center')};
  }
`;
const StyledPagination = styled.div `
  position: relative;
  text-align: center;

  --swiper-pagination-color: ${({ theme }) => theme.rio.semantic.color.imagePagination.selected};
  --swiper-pagination-bullet-inactive-color: ${({ theme }) => theme.rio.semantic.color.imagePagination.unselected};
  --swiper-pagination-bullet-inactive-opacity: 1;
`;
export const ImageSlider = ({ images, initialSlide = 0, showPagination = true, fullScreen = 'false', loop = true, }) => {
    const theme = useTheme();
    const swiperRef = React.useRef();
    // Reinit pagination on theme changes to fix CSS retention issues
    React.useEffect(() => {
        if (!swiperRef.current)
            return;
        swiperRef.current.pagination.init();
    }, [theme.mode]);
    return (_jsxs(_Fragment, { children: [_jsx(StyledSwiper, { modules: [Pagination], pagination: {
                    enabled: showPagination && images.length > 1,
                    el: '.swiper-pagination',
                    dynamicBullets: true,
                    dynamicMainBullets: 3,
                }, loop: images.length > 1 ? loop : false, initialSlide: initialSlide, fullscreen: fullScreen, onInit: (swiper) => {
                    swiperRef.current = swiper;
                }, onUpdate: (swiper) => {
                    // Reset the slide to 0 on variation changes
                    swiper.slideTo(0, 0);
                }, "data-testid": "image-swiper", children: images.map((image) => (_jsx(SwiperSlide, { "data-testid": "image-slide", children: _jsx(ImageContainer, { fullscreen: fullScreen, children: _jsx("img", { src: image.highRes || image.lowRes, alt: image.altText, onError: (e) => {
                                // Fallback to lowRes if highRes fails
                                const target = e.target;
                                if (target.src !== image.lowRes) {
                                    target.src = image.lowRes;
                                }
                            } }) }) }, image.highRes || image.lowRes))) }), _jsx(StyledPagination, { className: "swiper-pagination", "data-testid": "swiper-pagination" })] }));
};
